module.exports = __webpack_public_path__ + "static/media/bi.d0615c77.svg";